import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Location\UpdateLocationController::__invoke
* @see app/Http/Controllers/Location/UpdateLocationController.php
* @route '/api/location/{location}'
*/
const UpdateLocationController = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateLocationController.url(args, options),
    method: 'put',
})

UpdateLocationController.definition = {
    methods: ["put"],
    url: '/api/location/{location}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Location\UpdateLocationController::__invoke
* @see app/Http/Controllers/Location/UpdateLocationController.php
* @route '/api/location/{location}'
*/
UpdateLocationController.url = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { location: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { location: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            location: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        location: typeof args.location === 'object'
        ? args.location.id
        : args.location,
    }

    return UpdateLocationController.definition.url
            .replace('{location}', parsedArgs.location.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Location\UpdateLocationController::__invoke
* @see app/Http/Controllers/Location/UpdateLocationController.php
* @route '/api/location/{location}'
*/
UpdateLocationController.put = (args: { location: string | number | { id: string | number } } | [location: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateLocationController.url(args, options),
    method: 'put',
})

export default UpdateLocationController